import React, { useState } from 'react';
import { ModalBody, ModalFooter, Button, FormGroup, Label, Input } from 'reactstrap';

interface Props {
  // Paso "Cancelar" del modal único de detalle — no es un modal propio
  // (evita modal-sobre-modal), sólo el body/footer de ese paso.
  onCancel: () => void;
  onConfirm: (cancellationReason: string) => void;
}

// Calcado de src/pages/investors/components/DeleteVisitModal.tsx, pero el
// endpoint de Advisory (POST .../advisory-leads/:id/cancel) sólo pide
// `cancellation_reason` como texto libre — no hay un catálogo de reasons ni
// un status alterno (Advisory no tiene equivalente a "voided").
const CancelAdvisoryLeadForm: React.FC<Props> = ({ onCancel, onConfirm }) => {
  const [cancellationReason, setCancellationReason] = useState('');

  const handleConfirm = () => {
    if (!cancellationReason.trim()) return;
    onConfirm(cancellationReason.trim());
  };

  return (
    <>
      <ModalBody>
        <FormGroup>
          <Label for="cancel-advisory-reason">Motivo de la cancelación</Label>
          <Input
            type="textarea"
            id="cancel-advisory-reason"
            value={cancellationReason}
            onChange={(e) => setCancellationReason(e.target.value)}
            placeholder="Explica por qué se cancela esta asesoría"
            rows={3}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={onCancel}>
          Volver
        </Button>
        <Button
          color="danger"
          className="px-4"
          onClick={handleConfirm}
          disabled={!cancellationReason.trim()}
        >
          Cancelar asesoría
        </Button>
      </ModalFooter>
    </>
  );
};

export default CancelAdvisoryLeadForm;
